import { render, staticRenderFns } from "./order-stat.vue?vue&type=template&id=70f9e5b6&scoped=true"
import script from "./order-stat.vue?vue&type=script&lang=js"
export * from "./order-stat.vue?vue&type=script&lang=js"
import style0 from "./order-stat.vue?vue&type=style&index=0&id=70f9e5b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9e5b6",
  null
  
)

export default component.exports